import { watch } from 'vue';
import i18n from '@/assets/js/i18n';
import { useStore, useRouter } from '@/utils/vue-api';
import { replaceLocation } from '@/utils/api';
import { useNavigation } from './useNavigation';
import LoadingMask from '@rebuild/components/loading/loading';

export function useLangListeners() {
	const store = useStore();
	const router = useRouter();

	const { buildTemplatePath, buildTemplateQuery } = useNavigation();
	const replaceHome = lang => {
		const path = buildTemplatePath('index');
		const query = buildTemplateQuery({}, path);
		if (lang) {
			query.lang = lang;
		}
		const targetRoute = {
			path,
			query
		};
		const targetUrl = router.resolve(targetRoute).href;
		window.location.replace(targetUrl);
	};

	watch(
		() => i18n.locale,
		lang => {
			// 先开启遮罩层 然后重新加载页面
			LoadingMask.show();

			const url = store.getters.getHostConfig?.entryUrl;
			if (url) {
				replaceLocation(lang, url);
				return;
			}
			replaceHome(lang);
		}
	);
}
